import fetch from './fetch';

export default (email: string): Promise<void> =>
    fetch<void>('/user/logout', {
        method: 'POST',
        body: JSON.stringify({
            email,
        }),
    });
